











































































import albumCover from './bigAlbum/comps/albumCover.vue'
import AlbumAudios from './bigAlbum/comps/albumAudios.vue'
import AlbumDesc from './bigAlbum/comps/albumDesc.vue'
import store from '../store'
import buyPanel from "./_comps/buyPanel.vue"
import { isWeixin } from '@ivy/fts/utils'
import { toItem } from '../helper'
import { Component, Vue, Prop } from 'vue-property-decorator'
import openApp from '@ivy/fts/openApp'
import * as _ from 'underscore'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import showApp from '../components/showApp.vue'
@Component({
  components: { buyPanel, albumCover, AlbumAudios, AlbumDesc }
})

export default class AlbumInfo2 extends Vue {
  hideAlbum: any = [1633, 1632]
  limit: number = 10
  album: any = {} // 专辑信息
  tabActive: any = '1'
  audios: any = []
  if_more: boolean = false // 是否有下一页
  show_page: any = ''
  isWeixin: boolean = isWeixin()
  userInfo: any = {}
  isShow: boolean = true
  get from() {
    let from: any = this.$route.query.from
    return ['timeline', 'groupmessage', 'singlemessage'].includes(from) ? 'share' : this.$route.query.from
  }
  async mounted() {
    this.userInfo = (await store.login(this)) || {}
    let { result } = this.$route.query

    if (this.$route.query.from === 'qr' && this.hideAlbum.includes(+this.$route.params.albumId)) {
      this.isShow = false
    }
    const message = { 'chooseWXPay:ok': '专辑购买成功', 'chooseWXPay:cancel': '支付取消', 'chooseWXPay:fail': '支付失败' }
    if (result) {
      this.$Toast(message[`${result}`] || `${result}`)
    }
    await this.initPage().catch(e => {
      console.error('error: ', e)
    })
    this.show_page === 'desc' ? this.tabActive = '0' : this.tabActive = '1'
    // 设置分享时显示的图片和标题
    store.setupShare({
      imgUrl: this.album.share_data.pic_url + '?x-oss-process=image/resize,w_750',
      title: this.album.share_data.title,
      desc: this.album.share_data.content,
      link: this.album.share_data.url + this.$route.query.from === 'qr' ? '?from=qr' : '',
    })
  }
  toItem() {
    let data = _.find(this.audios, au => au.has_access === 1 || au.listen === 1) || this.audios[0]
    const opt = { data, type: 'audio', from: this.from, albumId: this.$route.query.albumId, memId: this.$route.query.memId, share_username: '$route.query.share_username' }
    toItem(opt)
  }
  async toApp() {
    showDiv(showApp, {
      closeAll
    })
  }
  async initPage() {
    this.album = {}
    this.audios = []
    await this.getAlbumInfo()
    await this.getAudioList()
  }
  async paySuccess(res) {
    if (res.r) {
      this.$Toast('专辑购买成功')
      await this.initPage()
    }
  }
  async getAlbumInfo() {
    // 获取albumInfo，旧接口`/api/mobile/resource/albumDetail`会将以下2次请求的数据一起返回
    let { data } = await this.$axios.get(`/api/mobile/audios/resource2/albumDetail`, {
      params: {
        ...this.$route.query,
        token: store.logined.token,
        id: this.$route.params.albumId,
        from: ['timeline', 'groupmessage', 'singlemessage'].includes(`${this.$route.query.from}`) ? 'share' : this.$route.query.from,
        includes: 'share_data,description,groups,audios,comment_count',
        isWechatLogin: this.$route.query.isWechatLogin === 'nologin' ? 'nologin' : ''
      }
    })
    this.album = data
    this.show_page = data.show_page
  }
  async getAudioList(limit = this.limit) {
    // 获取album下的audios
    let { data } = await this.$axios.get(`/api/mobile/audios/resource2/getAudioListByAlbumId`, {
      params: {
        token: store.logined.token,
        id: this.$route.params.albumId,
        limit,
        offset: this.audios.length,
        includes: 'comment_count',
        from: ['timeline', 'groupmessage', 'singlemessage'].includes(`${this.$route.query.from}`) ? 'share' : this.$route.query.from
      }
    })
    // if (this.$route.query.from === 'qr') {
    //   data = data.filter(c => ['律动', '故事', '歌曲', '童谣'].includes(c.audio_track))
    // }
    this.audios = [...this.audios, ...data]
    this.if_more = data.length === limit
  }
  async infiniteLoad() {
    if (!this.if_more) return
    await this.getAudioList()
  }
}
